//
//
//
//
//
//
//
//
//

export default {
  name: 'service'
}



// WEBPACK FOOTER //
// ./src/components/Service.vue